"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.captureAggregateMetrics = captureAggregateMetrics;
exports.createMetricEnvelope = createMetricEnvelope;

var _dsn = require("../utils-hoist/dsn.js");

var _envelope = require("../utils-hoist/envelope.js");

var _logger = require("../utils-hoist/logger.js");

var _utils = require("./utils.js");

/**
 * Captures aggregated metrics to the supplied client.
 */
function captureAggregateMetrics(client, metricBucketItems) {
  _logger.logger.log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);

  const dsn = client.getDsn();
  const metadata = client.getSdkMetadata();
  const tunnel = client.getOptions().tunnel;
  const metricsEnvelope = createMetricEnvelope(metricBucketItems, dsn, metadata, tunnel); // sendEnvelope should not throw
  // eslint-disable-next-line @typescript-eslint/no-floating-promises

  client.sendEnvelope(metricsEnvelope);
}
/**
 * Create envelope from a metric aggregate.
 */


function createMetricEnvelope(metricBucketItems, dsn, metadata, tunnel) {
  const headers = {
    sent_at: new Date().toISOString()
  };

  if (metadata && metadata.sdk) {
    headers.sdk = {
      name: metadata.sdk.name,
      version: metadata.sdk.version
    };
  }

  if (!!tunnel && dsn) {
    headers.dsn = (0, _dsn.dsnToString)(dsn);
  }

  const item = createMetricEnvelopeItem(metricBucketItems);
  return (0, _envelope.createEnvelope)(headers, [item]);
}

function createMetricEnvelopeItem(metricBucketItems) {
  const payload = (0, _utils.serializeMetricBuckets)(metricBucketItems);
  const metricHeaders = {
    type: 'statsd',
    length: payload.length
  };
  return [metricHeaders, payload];
}